<template>
    <CompanyBoxContent v-if="company && company.insolvencies" :title="$t('company.insolvency') + ':'">
        <template #data>
            <div class="col-12 box">
                <div v-for="insolvency in company.insolvencies" :key="insolvency.id" class="row">
                    <span v-if="insolvency.had_insolvency">{{ $t('company.hadInsolvency') }}</span>
                    <span v-if="insolvency.has_insolvency">{{ $t('company.hasInsolvency') }}</span>
                    <div v-if="insolvency.insolvency_type" class="row mt-1">
                        <span class="col-12">{{ $t('company.insolvencyState') }}:</span>
                        <span class="col-12">{{ insolvency.insolvency_type }}</span>
                    </div>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>

<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"

export default {
    props: {
        company: {
            type: Object,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
    },
    data() {
        return {

        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.insolvency_child:not(:last-child) {
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
    padding-bottom: 10px;
}
</style>